import * as actionType from './type';

const initialState = {
    isLoading: false,
    clientLabelData : [],
    currentHashMapData: {},
}

export default function (state = initialState, action) {
    switch(action.type) {
        case actionType.RECEIVED_GLOBALIZE_DATA: {
            return {
                ...state,
                clientLabelData: action?.payload?.data,
                currentHashMapData: action?.payload?.currentHashMapData,
                isLoading: false
            }
        }

        case actionType.REQUEST_UPDATE_HASH_MAP: {
            return {
                ...state,
                currentHashMapData: action?.payload
            }
        }

        case actionType.REQUEST_GLOBALIZE_DATA: {
            return {
                ...state,
                isLoading: action?.payload
            }
        }


        default: {
            return {
                ...state
            }
        }
    }
}